import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import React from 'react';
import { alyviaCoreServiceApi } from 'utils/constants';

type MediaInfo = {
  url: string;
  size: number;
  type: string;
  fileName: string;
};

export async function downloadMessageMedia(mediaUrl: string): Promise<MediaInfo> {
  const { data, headers } = await axios.post(
    `${alyviaCoreServiceApi}/messages/download?mediaUrl=${mediaUrl}`,
    {},
    {
      responseType: 'blob'
    }
  );

  let fileName = 'arquivo';

  const contentDisposition = headers['content-disposition'];
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?(.+?)"?$/);
    if (match) {
      fileName = decodeURIComponent(match[1]);
    }
  }

  if (!fileName || fileName === 'arquivo') {
    try {
      const urlPath = new URL(mediaUrl).pathname;
      const lastSegment = urlPath.split('/').pop();
      if (lastSegment) fileName = decodeURIComponent(lastSegment);
    } catch {
      // ignora erro de URL malformada e mantém fallback como "arquivo"
    }
  }
  return {
    url: URL.createObjectURL(data),
    size: data.size,
    type: data.type,
    fileName: fileName
  };
}

export function useDownloadMessageMedia(mediaUrl: string) {
  const query = useQuery({
    queryKey: ['mediaMessage', mediaUrl],
    queryFn: () => downloadMessageMedia(mediaUrl),
    enabled: !!mediaUrl,
    staleTime: 20000
  });

  // Cleanup automático do URL Blob
  React.useEffect(() => {
    return () => {
      if (query.data) {
        URL.revokeObjectURL(query.data.url);
      }
    };
  }, [query.data]);

  return query;
}
